import $http from '../../shared/http';

export const followers = {
  namespaced: true,

  actions: {
    async LOAD_CHURCH_FOLLOWERS(ctx, { orgId, query }) {
      return $http('v2').get(`organisations/${orgId}/church_followers`, {
        notifiable: true,
        params: query,
      });
    },
  },
};
